import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const RadioGroupWrapper = styled.div`
display: flex;
.MuiIconButton-colorSecondary {
    color: var(--primary);
}
.MuiRadio-colorSecondary.Mui-checked {
    color: var(--primary);
}
`;

export const RadioNames = styled.div`
display: flex;
font-size: 20px;
font-weight: 700;
max-width: ${props => props.maxWidth ? props.maxWidth : '606px'};
padding-bottom: 5px;
color: var(--primary);
.MuiTypography-body1 {
    font-size: 20px;
}
`;

export const RadioLabel = styled.div`
margin: ${props => props.margin ? props.margin : '0 1rem'};
padding: 10px 0;
font-size: 20px;
font-weight: 700;
color: var(--primary);
`;
export const useStyles = makeStyles(() => ({
    root: {
        width: '550px',
        alignSelf: 'center',
        '&.MuiLinearProgress-root .MuiLinearProgress-barColorPrimary': {
            backgroundColor: 'var(--primary)'
        },
        '&.MuiLinearProgress-colorPrimary': {
            backgroundColor: '#B6BCE2'
        },
    },
}));
